const Footer = () => {
  const env = process.env.REACT_APP_ENV;

  if (env !== "staging") return null; // Only show on staging

  return (
    <footer className="absolute bottom-0 flex flex-col gap-1 md:flex-row md:justify-between w-full text-center py-4 px-4 text-xs mt-4">
      <p className="md:text-white">
        © {new Date().getFullYear()} Khuddam Chanda System
      </p>
      <p>
        Powered by{" "}
        <a
          href="https://www.linkedin.com/in/nafees27"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline"
        >
          Nafees Ahmad Muneeb
        </a>
      </p>
    </footer>
  );
};

export default Footer;
